import { LOCALES } from "app/language/model"
import { ACTIONS } from "app/store/actions"
import { Action } from "redux"
import {
  ISignUpAgencyForm,
  ISignUpUserForm,
  IUserImpersonateSession,
  IUserInfo,
  SIGNUP_STATUS,
  SIGNUP_WIZARD_STEPS
} from "user/model"

export interface IUserActionLogin extends Action {
  userInfo: IUserInfo
  impersonateSession?: IUserImpersonateSession
}

export interface IUserActionSetSignupStatus extends Action {
  status: SIGNUP_STATUS
}

export interface IUserActionSetSignupWizardStep extends Action {
  step: SIGNUP_WIZARD_STEPS
}

export interface IUserActionSetSignupWizardUserForm extends Action {
  form: Partial<ISignUpUserForm>
}

export interface IUserActionSetSignupWizardAgencyForm extends Action {
  form: Partial<ISignUpAgencyForm>
}

export interface IUserActionClearSignupWizard extends Action {
  locale?: LOCALES
}

export const userActionCreator = {
  startLoggingIn(): Action {
    return {
      type: ACTIONS.USER_START_LOGGING_IN
    }
  },
  stopLoggingIn(): Action {
    return {
      type: ACTIONS.USER_STOP_LOGGING_IN
    }
  },
  login(userInfo: IUserInfo, impersonateSession?: IUserImpersonateSession): IUserActionLogin {
    return {
      type: ACTIONS.USER_LOGIN,
      userInfo,
      impersonateSession
    }
  },
  logout(): Action {
    return { type: ACTIONS.USER_LOGOUT }
  },
  renewSession(userInfo: IUserInfo): IUserActionLogin {
    return {
      type: ACTIONS.USER_RENEW_SESSION,
      userInfo
    }
  },
  openReLoginPopup(): Action {
    return { type: ACTIONS.USER_OPEN_RE_LOGIN_POPUP }
  },
  clearSignUp(locale?: LOCALES): IUserActionClearSignupWizard {
    return { type: ACTIONS.USER_SIGN_UP_WIZARD_CLEAR, locale }
  },
  clearSignUpStatus(): Action {
    return { type: ACTIONS.USER_SIGN_UP_WIZARD_CLEAR_STATUS }
  },
  setSignUpStatus(status: SIGNUP_STATUS): IUserActionSetSignupStatus {
    return {
      type: ACTIONS.USER_SIGN_UP_SET_STATUS,
      status
    }
  },
  setSignUpStep(step: SIGNUP_WIZARD_STEPS): IUserActionSetSignupWizardStep {
    return {
      type: ACTIONS.USER_SIGN_UP_WIZARD_SET_STEP,
      step
    }
  },
  setSignUpUserForm(form: Partial<ISignUpUserForm>): IUserActionSetSignupWizardUserForm {
    return {
      type: ACTIONS.USER_SIGN_UP_WIZARD_SET_USER_FORM,
      form
    }
  },
  setSignUpAgencyForm(form: Partial<ISignUpAgencyForm>): IUserActionSetSignupWizardAgencyForm {
    return {
      type: ACTIONS.USER_SIGN_UP_WIZARD_SET_AGENCY_FORM,
      form
    }
  }
}
